import React from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import { Dropdown, Icon, Menu } from 'semantic-ui-react';

import UserWrapper from '../../user/User';
import { WrapFollowUpContext } from '../../../context/FollowUpContext';
import MenuItemsWithPoll from '../MenuItemsWithPoll';
import { showModal } from '../../../actions/uiActions';

const TopMenu = ({ userStateActions, currentUser }) => {
    const history = useHistory();
    const changePasswordClicked = () => {
        history.push('/changePassword');
    };
    return (
        <Menu secondary className="top-menu">
            {currentUser.loggedIn && (
                <Menu.Menu position="right">
                    <Menu.Item>
                        {currentUser.fullname} -{' '}
                        {currentUser.details.party
                            ? currentUser.details.party.label
                            : ''}
                    </Menu.Item>

                    <Dropdown
                        item
                        icon={<Icon name="user" size="large" />}
                        simple
                        className="right"
                    >
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={changePasswordClicked}>
                                Change Password
                            </Dropdown.Item>
                            <Dropdown.Item onClick={userStateActions.logout}>
                                Logout
                            </Dropdown.Item>
                            {currentUser.loggedInAsUser && (
                                <Dropdown.Item
                                    onClick={
                                        userStateActions.returnToOriginalUser
                                    }
                                >
                                    Return to User
                                </Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>

                    <MenuItemsWithPoll />

                    <Menu.Item
                        onClick={() => window.open('/help', 'helpWindow')}
                    >
                        <Icon name="help circle" size="large" color="black" />
                    </Menu.Item>
                </Menu.Menu>
            )}
        </Menu>
    );
};

TopMenu.propTypes = {
    userStateActions: PropTypes.object.isRequired,
    uiActions: PropTypes.object.isRequired,
    currentUser: PropTypes.object,
    currentUsers: PropTypes.array,
    followUpList: PropTypes.array,
    events: PropTypes.object,
};

export default withRouter(WrapFollowUpContext(UserWrapper(TopMenu)));
